/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil } from 'rxjs/operators';
import {
    CompaniesAction,
    CompaniesActionType,
    fetchCompaniesListSuccessAction,
    fetchCompaniesListErrorAction,
    downloadCompaniesListAsExcelSuccessAction,
    downloadCompaniesListAsExcelErrorAction,
} from '../actions/companiesActions';
import { CompaniesState } from '../reducers/companiesReducer';
import { CompaniesListRequestParams } from '../api/companies/companiesClient.typings';
import { of, from } from 'rxjs';
import { companiesClient } from '../api/companies/companiesClient';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from 'data/translation/i18n';

export const getCompaniesListEpic: Epic<CompaniesAction> = (action$, state) => {
    return action$.pipe(
        ofType(CompaniesActionType.FETCH_NEXT_PAGE_START, CompaniesActionType.APPLY_FILTERS),
        switchMap(() => {
            const queryParams = makeStoresListRequestParamsFromState(state.value.companiesReducer);
            return from(companiesClient.listCompanies(queryParams)).pipe(
                map((resp) => fetchCompaniesListSuccessAction(resp)),
                catchError((err: AxiosError) =>
                    of(
                        fetchCompaniesListErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.companiesListNotFound')),
                        ),
                    ),
                ),

                takeUntil(action$.ofType(CompaniesActionType.EXIT_REGISTRY_COMPANIES_LIST_PAGE)),
            );
        }),
    );
};

function makeStoresListRequestParamsFromState(state: CompaniesState): CompaniesListRequestParams {
    return {
        ...state.filterParams,
        limit: state.limit,
        afterKey: state.afterKey,
    };
}

export const companiesListDownloadEpic: Epic<CompaniesAction> = (action$, state) => {
    return action$.pipe(
        ofType(CompaniesActionType.DOWNLOAD_EXCEL),
        switchMap(() => {
            return from(
                companiesClient.downloadCompaniesListAsExcel({ ...state.value.companiesReducer.filterParams }),
            ).pipe(
                map(() => downloadCompaniesListAsExcelSuccessAction()),

                catchError((err: AxiosError) =>
                    of(
                        downloadCompaniesListAsExcelErrorAction(
                            parseError(err, i18n.t('downloadings.errors.requestToCreateFileFailed')),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(CompaniesActionType.EXIT_REGISTRY_COMPANIES_LIST_PAGE)),
            );
        }),
    );
};
